import { FC } from 'react';
import './Loader.less';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  inline?: boolean;
}

const Loader: FC<LoaderProps> = ({ size = 'medium', inline = false }) => {
  return (
    <div className={`loader-container ${inline ? 'loader-inline' : ''} loader-${size}`}>
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
